import { BCMSCurrency, BrandingStyle, useBCMSModal, useStateManager } from "@bcm-dev/bcms-vite";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle } from "components/custom-ui/CustomAccordion";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from 'components/custom-ui/DateSelect';
import { FormContainer, FormRowView } from 'components/shared';
import IconToggle from "components/shared/views/IconToggle";
import { UIAmountInput, UITextInput } from 'components/ui';
import React, { useEffect, useState } from 'react';
import { SVGAsset } from "res";
import TASPositivePayAddChecksPageCheckForm from "../../classes/TASPositivePayAddChecksPageCheckForm";

/**
 * @function TASPositivePayAddChecksMobileView
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Add Check mobile content view.
 */
export default function TASPositivePayAddChecksMobileView(props) {
    const { data, ui, onChange, onMobileSave, onMobileCancel, onMobileEdit } = useStateManager();
    const defaultEditCheckForms = props.edit.editCheckForms;
    const [ stateEditCheckForms, setStateEditCheckForms ] = useState([ ...defaultEditCheckForms ]);
    const { open, close } = useBCMSModal();

    // Reset the check form in the state only, not globally.
    const onModalYesClick = checkFormID => val => {
        var editCheckForms = [ ...stateEditCheckForms ];
        var index = editCheckForms.findIndex(item => item.id === checkFormID);
        var selectedCheckForm = editCheckForms[index];
        var checkForm = TASPositivePayAddChecksPageCheckForm.init({ ...selectedCheckForm.record });
        checkForm = checkForm.reset();    
        editCheckForms.splice(index, 1, checkForm);
        setStateEditCheckForms([ ...editCheckForms ]);
    }

    const openModal = checkFormID => val => {
        open("TASPositivePayCancelAddCheckModal", { onYesClick: onModalYesClick(checkFormID) } );
    }
 
    const onMobileChange = (id, prop, setVal) => val => {
        var editCheckForms = [ ...stateEditCheckForms ];
        var index = editCheckForms.findIndex(item => item.id === id);
        var selectedCheckForm = editCheckForms[index];
        var checkForm = TASPositivePayAddChecksPageCheckForm.init({ ...selectedCheckForm.record });

        if(prop === "amount") {
            checkForm[prop] = val.amount;
        } else {
            checkForm[prop] = setVal ? setVal : val;
        }
    
        editCheckForms.splice(index, 1, checkForm);
        setStateEditCheckForms([ ...editCheckForms ]);
    };

    useEffect(() => {
        setStateEditCheckForms([ ...props.edit.editCheckForms ]);
        
        if(props.cancelModal.isActive) {
            open("TASPositivePayCancelAddCheckModal", { onYesClick: onModalYesClick("0") } );
        }
    }, [ props.edit, props.cancelModal ]);

    const rows = stateEditCheckForms.reduce((acc, item, index) => {
        const chevronIconClosedClass = item.mobileViewIsOpen ? "" : "closed";
        const amount = defaultEditCheckForms[index].amount ? BCMSCurrency.init(defaultEditCheckForms[index].amount).format() : undefined;
        const editAmount = item.amount ? BCMSCurrency.init(item.amount).format() : undefined;

        acc.push(
            <div key={ item.id } className="show-on-mobile">
                <div className="flex-container align-top">
                    <CustomAccordion isOpen={ item.mobileViewIsOpen }>
                        <div className="flex-container flex-horizontal align-top check-custom-accordion-content">
                                <div className="set-width">
                                    <CustomAccordionToggle className={ "search" } onClick={ onMobileChange(item.id, "mobileViewIsOpen") }>
                                        <IconToggle className={ `chevron-icon-container ${ chevronIconClosedClass }`} icon="DownChevronIcon" text=""/>
                                    </CustomAccordionToggle>
                                </div>
                                <div className="flex-width">
                                    <div className="flex-container flex-vertical check-details">
                                        <div className="check-detail-row">
                                            <span className="sub-text">Account: </span>
                                            <b>{ defaultEditCheckForms[index].accountName } - { item.accountNumber }</b>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="sub-text">Issued Date: </span>
                                            <b>{ defaultEditCheckForms[index].issuedDate.format("m/d/Y") }</b>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="sub-text">Check Number: </span>
                                            <b>{ defaultEditCheckForms[index].checkNumber }</b>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="sub-text">Amount: </span>
                                            <b>{ amount }</b>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        { item.mobileViewIsEditing && 
                        <CustomAccordionContent className="flex-container flex-vertical tas-positive-pay-add-check-page-accordion-content">
                            <CustomAccordionToggle className="flex-container flex-width close-accordion accordion-edit-view" onClick={ onMobileChange(item.id, "mobileViewIsOpen") }>
                                <BrandingStyle className="flex-width sub-text" element={<p >EDIT CHECK</p>}/>
                                <SVGAsset className="icon set-width" id="CloseX" data-point="CloseButton" />
                            </CustomAccordionToggle>
                            <FormContainer className="small-form-width">
                                <FormRowView text="Issued Date">
                                    <DateSelect active={ ui.editCheckForms[index].issuedDate.isActive } enablePast={ true } value={ item.issuedDate } onChange={ onMobileChange(item.id, "issuedDate") } />
                                </FormRowView>
                                <FormRowView text="Check Number">
                                    <UITextInput value={ item.checkNumber } onChange={ onMobileChange(item.id, "checkNumber") } />
                                </FormRowView>
                                <FormRowView text="Amount">
                                    <UIAmountInput className="amount-field" value={ item.amount } onChange={ onMobileChange(item.id, "amount") } />
                                </FormRowView>
                                <FormRowView text="Payee">
                                    <UITextInput value={ item.payee } onChange={ onMobileChange(item.id, "payee") } />
                                </FormRowView>
                                <FormRowView text="Reference Number">
                                    <UITextInput value={ item.referenceNumber } onChange={ onMobileChange(item.id, "referenceNumber") } />
                                </FormRowView>
                                <FormRowView className="type-form-view" text="Type">
                                    <CustomSelect active={ ui.editCheckForms[index].type.isActive } value={ item.type } onChange={ onMobileChange(item.id, "type") }>
                                        <CustomSelectItem value="issue">Issue</CustomSelectItem>
                                        <CustomSelectItem value="stop">Stop</CustomSelectItem>
                                        <CustomSelectItem value="void">Void</CustomSelectItem>
                                    </CustomSelect>
                                </FormRowView>
                                <div className="flex-container flex-vertical">
                                    <a className="clickable save" onClick={ onMobileSave(item.id, stateEditCheckForms) }>Save</a>
                                    <a className="clickable cancel" onClick={ openModal(item.id) }>Cancel</a>
                                </div>
                            </FormContainer>
                        </CustomAccordionContent>
                        }
                        { !item.mobileViewIsEditing && 
                        <CustomAccordionContent className="flex-container flex-vertical">
                            <CustomAccordionToggle className="flex-container flex-width close-accordion accordion-edit-view" onClick={ onMobileChange(item.id, "mobileViewIsOpen") }>
                                <BrandingStyle className="flex-width sub-text" element={<p >DETAILS</p>}/>
                                <SVGAsset className="icon set-width" id="CloseX" data-point="CloseButton" />
                            </CustomAccordionToggle>
                            <FormContainer className="small-form-width">
                                <FormRowView className="sub-text" text="Issued Date">
                                    <b>{ item.issuedDate.format("m/d/Y") }</b>
                                </FormRowView>
                                <FormRowView className="sub-text" text="Check Number">
                                    <b>{ item.checkNumber }</b>
                                </FormRowView>
                                <FormRowView className="sub-text" text="Amount">
                                    <b>{ editAmount }</b>
                                </FormRowView>
                                <FormRowView className="sub-text" text="Payee">
                                    <b>{ item.payee }</b>
                                </FormRowView>
                                <FormRowView className="sub-text" text="Reference Number">
                                    <b>{ item.referenceNumber }</b>
                                </FormRowView>
                                <FormRowView className="sub-text type type-form-view" text="Type">
                                    <b>{ item.type }</b>
                                </FormRowView>
                                <div className="flex-container flex-vertical">
                                    <a className="clickable" onClick={ onChange(item.id, "mobileViewIsEditing", true) }>Edit</a>
                                </div>
                            </FormContainer>
                        </CustomAccordionContent>
                        }
                    </CustomAccordion>
                </div>
            </div>
        );
        return acc;
    }, [])
    
    return rows;
}